import React, { useEffect, useState } from 'react'
import {
  IconButton,
  Icon,
  Typography,
} from '@mui/material'

import * as srv from 'admin/services'
import { formatDateTimeSeconds } from 'admin/utils/helper'
import { useStores, useApiRequest } from 'admin/hooks'

const SyncButton = ({ className }) => {
  const [currentSync, setCurrentSync] = useState(null)
  const { invoiceStore, notificationStore } = useStores()
  const {
    request: syncInvoice,
    isLoading,
  } = useApiRequest(srv.syncInvoice, { blocking: true })
  const {
    request: fetchCurrentSync,
  } = useApiRequest(srv.fetchCurrentSync, { blocking: true })

  const fetchSync = async () => {
    try {
      const response = await fetchCurrentSync('order')
      setCurrentSync(response.data)
    } catch (error) {
      notificationStore.setError(error)
    }
  }

  const handleSync = async () => {
    if (isLoading) return
    const res = await syncInvoice()
    if (!res) return

    await invoiceStore.reload()
    fetchSync()
    notificationStore.setSuccess('Invoice is sync')
  }

  useEffect(() => {
    fetchSync()
  }, [])

  return (
    <div style={{ display: 'flex' }} className={className}>
      <IconButton
        variant="contained"
        color="secondary"
        onClick={handleSync}
        disabled={isLoading}
        size="large"
      >
        <Icon>sync</Icon>
      </IconButton>
      {currentSync?.syncUpdatedAt && (
        <div>
          <Typography variant="body2">
            Last Sync
          </Typography>
          <Typography variant="body2">
            {formatDateTimeSeconds(currentSync.syncUpdatedAt)}
          </Typography>
        </div>
      )}
    </div>
  )
}

export default SyncButton
